
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91_46_46_46all_93VO0fsRNy81Meta } from "/home/zebrafashion/zebrafashion.com/releases/75947690/pages/[...all].vue?macro=true";
import { default as addressd43nvo7iuDMeta } from "/home/zebrafashion/zebrafashion.com/releases/75947690/pages/account/address.vue?macro=true";
import { default as index2jBbkVMTDCMeta } from "/home/zebrafashion/zebrafashion.com/releases/75947690/pages/account/index.vue?macro=true";
import { default as orderVFdu5MNpiNMeta } from "/home/zebrafashion/zebrafashion.com/releases/75947690/pages/account/order.vue?macro=true";
import { default as paymentdt43mXE2zxMeta } from "/home/zebrafashion/zebrafashion.com/releases/75947690/pages/account/payment.vue?macro=true";
import { default as profileoh6BaS7KQFMeta } from "/home/zebrafashion/zebrafashion.com/releases/75947690/pages/account/profile.vue?macro=true";
import { default as index9ciw68iuMSMeta } from "/home/zebrafashion/zebrafashion.com/releases/75947690/pages/account/recover/index.vue?macro=true";
import { default as passwordGYKdcmM48EMeta } from "/home/zebrafashion/zebrafashion.com/releases/75947690/pages/account/recover/password.vue?macro=true";
import { default as cartgUXoo8RWpKMeta } from "/home/zebrafashion/zebrafashion.com/releases/75947690/pages/checkout/cart.vue?macro=true";
import { default as indexgZwTfyNbh3Meta } from "/home/zebrafashion/zebrafashion.com/releases/75947690/pages/checkout/index.vue?macro=true";
import { default as indexQGOiYIiHQ9Meta } from "/home/zebrafashion/zebrafashion.com/releases/75947690/pages/checkout/success/[id]/index.vue?macro=true";
import { default as paidoV8WvEw3paMeta } from "/home/zebrafashion/zebrafashion.com/releases/75947690/pages/checkout/success/[id]/paid.vue?macro=true";
import { default as unpaidfBCRYlN9MyMeta } from "/home/zebrafashion/zebrafashion.com/releases/75947690/pages/checkout/success/[id]/unpaid.vue?macro=true";
import { default as authorizeS69vGOep9OMeta } from "/home/zebrafashion/zebrafashion.com/releases/75947690/pages/hla/authorize.vue?macro=true";
import { default as login1Jyy73S0d6Meta } from "/home/zebrafashion/zebrafashion.com/releases/75947690/pages/login.vue?macro=true";
import { default as newsletter_45subscribeZQ9zvWCWMaMeta } from "/home/zebrafashion/zebrafashion.com/releases/75947690/pages/newsletter-subscribe.vue?macro=true";
import { default as registerIFuEb6bNjzMeta } from "/home/zebrafashion/zebrafashion.com/releases/75947690/pages/register.vue?macro=true";
import { default as reset_45passwordSsZBqDmVw8Meta } from "/home/zebrafashion/zebrafashion.com/releases/75947690/pages/reset-password.vue?macro=true";
import { default as searchnY5mYxaybKMeta } from "/home/zebrafashion/zebrafashion.com/releases/75947690/pages/search.vue?macro=true";
import { default as sentry_45testR8JXtQpBK6Meta } from "/home/zebrafashion/zebrafashion.com/releases/75947690/pages/sentry-test.vue?macro=true";
import { default as shopwareHmkrio9u48Meta } from "/home/zebrafashion/zebrafashion.com/releases/75947690/pages/shopware.vue?macro=true";
import { default as wishlisthlsXbnzmyNMeta } from "/home/zebrafashion/zebrafashion.com/releases/75947690/pages/wishlist.vue?macro=true";
import { default as component_45stubNuSE2AoQSWMeta } from "/home/zebrafashion/zebrafashion.com/releases/75947690/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubNuSE2AoQSW } from "/home/zebrafashion/zebrafashion.com/releases/75947690/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "all___fr-FR",
    path: "/fr-FR/:all(.*)*",
    component: () => import("/home/zebrafashion/zebrafashion.com/releases/75947690/pages/[...all].vue")
  },
  {
    name: "all___de-DE",
    path: "/:all(.*)*",
    component: () => import("/home/zebrafashion/zebrafashion.com/releases/75947690/pages/[...all].vue")
  },
  {
    name: "account-address___fr-FR",
    path: "/fr-FR/account/address",
    meta: addressd43nvo7iuDMeta || {},
    component: () => import("/home/zebrafashion/zebrafashion.com/releases/75947690/pages/account/address.vue")
  },
  {
    name: "account-address___de-DE",
    path: "/account/address",
    meta: addressd43nvo7iuDMeta || {},
    component: () => import("/home/zebrafashion/zebrafashion.com/releases/75947690/pages/account/address.vue")
  },
  {
    name: "account___fr-FR",
    path: "/fr-FR/account",
    meta: index2jBbkVMTDCMeta || {},
    component: () => import("/home/zebrafashion/zebrafashion.com/releases/75947690/pages/account/index.vue")
  },
  {
    name: "account___de-DE",
    path: "/account",
    meta: index2jBbkVMTDCMeta || {},
    component: () => import("/home/zebrafashion/zebrafashion.com/releases/75947690/pages/account/index.vue")
  },
  {
    name: "account-order___fr-FR",
    path: "/fr-FR/account/order",
    meta: orderVFdu5MNpiNMeta || {},
    component: () => import("/home/zebrafashion/zebrafashion.com/releases/75947690/pages/account/order.vue")
  },
  {
    name: "account-order___de-DE",
    path: "/account/order",
    meta: orderVFdu5MNpiNMeta || {},
    component: () => import("/home/zebrafashion/zebrafashion.com/releases/75947690/pages/account/order.vue")
  },
  {
    name: "account-payment___fr-FR",
    path: "/fr-FR/account/payment",
    meta: paymentdt43mXE2zxMeta || {},
    component: () => import("/home/zebrafashion/zebrafashion.com/releases/75947690/pages/account/payment.vue")
  },
  {
    name: "account-payment___de-DE",
    path: "/account/payment",
    meta: paymentdt43mXE2zxMeta || {},
    component: () => import("/home/zebrafashion/zebrafashion.com/releases/75947690/pages/account/payment.vue")
  },
  {
    name: "account-profile___fr-FR",
    path: "/fr-FR/account/profile",
    meta: profileoh6BaS7KQFMeta || {},
    component: () => import("/home/zebrafashion/zebrafashion.com/releases/75947690/pages/account/profile.vue")
  },
  {
    name: "account-profile___de-DE",
    path: "/account/profile",
    meta: profileoh6BaS7KQFMeta || {},
    component: () => import("/home/zebrafashion/zebrafashion.com/releases/75947690/pages/account/profile.vue")
  },
  {
    name: "account-recover___fr-FR",
    path: "/fr-FR/account/recover",
    component: () => import("/home/zebrafashion/zebrafashion.com/releases/75947690/pages/account/recover/index.vue")
  },
  {
    name: "account-recover___de-DE",
    path: "/account/recover",
    component: () => import("/home/zebrafashion/zebrafashion.com/releases/75947690/pages/account/recover/index.vue")
  },
  {
    name: "account-recover-password___fr-FR",
    path: "/fr-FR/account/recover/password",
    component: () => import("/home/zebrafashion/zebrafashion.com/releases/75947690/pages/account/recover/password.vue")
  },
  {
    name: "account-recover-password___de-DE",
    path: "/account/recover/password",
    component: () => import("/home/zebrafashion/zebrafashion.com/releases/75947690/pages/account/recover/password.vue")
  },
  {
    name: "checkout-cart___fr-FR",
    path: "/fr-FR/checkout/cart",
    component: () => import("/home/zebrafashion/zebrafashion.com/releases/75947690/pages/checkout/cart.vue")
  },
  {
    name: "checkout-cart___de-DE",
    path: "/checkout/cart",
    component: () => import("/home/zebrafashion/zebrafashion.com/releases/75947690/pages/checkout/cart.vue")
  },
  {
    name: "checkout___fr-FR",
    path: "/fr-FR/checkout",
    meta: indexgZwTfyNbh3Meta || {},
    component: () => import("/home/zebrafashion/zebrafashion.com/releases/75947690/pages/checkout/index.vue")
  },
  {
    name: "checkout___de-DE",
    path: "/checkout",
    meta: indexgZwTfyNbh3Meta || {},
    component: () => import("/home/zebrafashion/zebrafashion.com/releases/75947690/pages/checkout/index.vue")
  },
  {
    name: "checkout-success-id___fr-FR",
    path: "/fr-FR/checkout/success/:id()",
    component: () => import("/home/zebrafashion/zebrafashion.com/releases/75947690/pages/checkout/success/[id]/index.vue")
  },
  {
    name: "checkout-success-id___de-DE",
    path: "/checkout/success/:id()",
    component: () => import("/home/zebrafashion/zebrafashion.com/releases/75947690/pages/checkout/success/[id]/index.vue")
  },
  {
    name: "checkout-success-id-paid___fr-FR",
    path: "/fr-FR/checkout/success/:id()/paid",
    component: () => import("/home/zebrafashion/zebrafashion.com/releases/75947690/pages/checkout/success/[id]/paid.vue")
  },
  {
    name: "checkout-success-id-paid___de-DE",
    path: "/checkout/success/:id()/paid",
    component: () => import("/home/zebrafashion/zebrafashion.com/releases/75947690/pages/checkout/success/[id]/paid.vue")
  },
  {
    name: "checkout-success-id-unpaid___fr-FR",
    path: "/fr-FR/checkout/success/:id()/unpaid",
    component: () => import("/home/zebrafashion/zebrafashion.com/releases/75947690/pages/checkout/success/[id]/unpaid.vue")
  },
  {
    name: "checkout-success-id-unpaid___de-DE",
    path: "/checkout/success/:id()/unpaid",
    component: () => import("/home/zebrafashion/zebrafashion.com/releases/75947690/pages/checkout/success/[id]/unpaid.vue")
  },
  {
    name: "hla-authorize___fr-FR",
    path: "/fr-FR/hla/authorize",
    component: () => import("/home/zebrafashion/zebrafashion.com/releases/75947690/pages/hla/authorize.vue")
  },
  {
    name: "hla-authorize___de-DE",
    path: "/hla/authorize",
    component: () => import("/home/zebrafashion/zebrafashion.com/releases/75947690/pages/hla/authorize.vue")
  },
  {
    name: "login___fr-FR",
    path: "/fr-FR/login",
    component: () => import("/home/zebrafashion/zebrafashion.com/releases/75947690/pages/login.vue")
  },
  {
    name: "login___de-DE",
    path: "/login",
    component: () => import("/home/zebrafashion/zebrafashion.com/releases/75947690/pages/login.vue")
  },
  {
    name: "newsletter-subscribe___fr-FR",
    path: "/fr-FR/newsletter-subscribe",
    component: () => import("/home/zebrafashion/zebrafashion.com/releases/75947690/pages/newsletter-subscribe.vue")
  },
  {
    name: "newsletter-subscribe___de-DE",
    path: "/newsletter-subscribe",
    component: () => import("/home/zebrafashion/zebrafashion.com/releases/75947690/pages/newsletter-subscribe.vue")
  },
  {
    name: "register___fr-FR",
    path: "/fr-FR/register",
    component: () => import("/home/zebrafashion/zebrafashion.com/releases/75947690/pages/register.vue")
  },
  {
    name: "register___de-DE",
    path: "/register",
    component: () => import("/home/zebrafashion/zebrafashion.com/releases/75947690/pages/register.vue")
  },
  {
    name: "reset-password___fr-FR",
    path: "/fr-FR/reset-password",
    component: () => import("/home/zebrafashion/zebrafashion.com/releases/75947690/pages/reset-password.vue")
  },
  {
    name: "reset-password___de-DE",
    path: "/reset-password",
    component: () => import("/home/zebrafashion/zebrafashion.com/releases/75947690/pages/reset-password.vue")
  },
  {
    name: "search___fr-FR",
    path: "/fr-FR/search",
    component: () => import("/home/zebrafashion/zebrafashion.com/releases/75947690/pages/search.vue")
  },
  {
    name: "search___de-DE",
    path: "/search",
    component: () => import("/home/zebrafashion/zebrafashion.com/releases/75947690/pages/search.vue")
  },
  {
    name: "sentry-test___fr-FR",
    path: "/fr-FR/sentry-test",
    component: () => import("/home/zebrafashion/zebrafashion.com/releases/75947690/pages/sentry-test.vue")
  },
  {
    name: "sentry-test___de-DE",
    path: "/sentry-test",
    component: () => import("/home/zebrafashion/zebrafashion.com/releases/75947690/pages/sentry-test.vue")
  },
  {
    name: "shopware___fr-FR",
    path: "/fr-FR/shopware",
    component: () => import("/home/zebrafashion/zebrafashion.com/releases/75947690/pages/shopware.vue")
  },
  {
    name: "shopware___de-DE",
    path: "/shopware",
    component: () => import("/home/zebrafashion/zebrafashion.com/releases/75947690/pages/shopware.vue")
  },
  {
    name: "wishlist___fr-FR",
    path: "/fr-FR/wishlist",
    component: () => import("/home/zebrafashion/zebrafashion.com/releases/75947690/pages/wishlist.vue")
  },
  {
    name: "wishlist___de-DE",
    path: "/wishlist",
    component: () => import("/home/zebrafashion/zebrafashion.com/releases/75947690/pages/wishlist.vue")
  },
  {
    name: component_45stubNuSE2AoQSWMeta?.name,
    path: "/.well-known/appspecific/:pathMatch(.*)",
    component: component_45stubNuSE2AoQSW
  }
]